import React from 'react';
import { string, func, number, bool, any } from 'prop-types';
import styled from 'styled-components';
import { RESOLUTIONS } from 'services/config';
import { CircleSlash } from 'styled_components/SVG/CircleSlash';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const Icon = styled.div`
	width: 24px;
	height: 24px;
	position: relative;
	overflow: hidden;
	background: ${props => props.theme.Cool_Gray_Light_3};
	border-radius: 4px;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: -1.5px -1.5px 2px ${props => props.theme.white},
		1.5px 1.5px 2px ${props => props.theme.boxShadow};
	svg {
		width: 14px;
		height: 20px;
		z-index: 1000;
	}
	img {
		width: 10px;
		height: 10px;
	}
	&::before {
		height: 50px;
		width: 300px;
		content: '';
		position: absolute;
		left: 0px;
		right: 0px;
		top: 0px;
		background: ${props => handleColorType(props.module, props.theme)};
		transform: translatex(-100%);
		//z-index: -1;
		z-index: 100;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 32px;
		height: 32px;
		box-shadow: -2px -2px 4px ${props => props.theme.white},
			3px 3px 6px ${props => props.theme.boxShadow};
		svg {
			width: 16px;
			height: 24px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 40px;
		height: 40px;
		box-shadow: -2.5px -2.5px 5px ${props => props.theme.white},
			3.5px 3.5px 7px ${props => props.theme.boxShadow};
		svg {
			width: 20px;
			height: 32px;
		}
	}
	&:hover {
		box-shadow: -2px -2px 2px ${props => props.theme.white} inset,
			0.5px 0.5px 2px ${props => props.theme.neomhorphicShadowDark} inset;
		&.medium {
			box-shadow: -2.5px -2.5px 3px ${props => props.theme.white} inset,
				1px 1px 2px ${props => props.theme.neomhorphicShadowDark} inset;
		}
		&.large {
			box-shadow: -3px -3px 3px ${props => props.theme.white} inset,
				1.5px 1.5px 3px ${props => props.theme.neomhorphicShadowDark} inset;
		}
		.daily {
			fill: ${props => handleColorType(props.module, props.theme)};
		}
		&.active {
			.daily {
				fill: url(#daily-selector-3-swipe-gradient);
			}
		}
	}
	&.active {
		background-position: left bottom;
		box-shadow: -1px -1px 2px ${props => props.theme.neomhorphicShadowLight} inset,
			1.5px 1.5px 3px ${props => props.theme.neomhorphicShadowDark} inset !important;

		&.medium {
			box-shadow: -1.5px -1.5px 2px ${props => props.theme.neomhorphicShadowLight}) inset,
				2px 2px 3px ${props => props.theme.neomhorphicShadowDark} inset !important;
		}
		&.large {
			box-shadow: -3px -3px 3px ${props => props.theme.neomhorphicShadowLight} inset,
				2px 2px 3px ${props => props.theme.neomhorphicShadowDark} inset !important;
		}
		&::before {
			animation: diagonal-swipe 1s ease forwards;
			opacity: 0;
			transition-delay: 0.1s;
			transition-property: opacity;
			transition-timing-function: ease;
			transition-duration: 0s;
		}
		transition-delay: 0.1s;
		background-color: ${props => handleColorType(props.module, props.theme)};
		transition-timing-function: ease;
		transition-property: background-color;
		transition-duration: 0s;
		.daily {
			fill: url(#daily-selector-3-swipe-gradient);
		}
	}
`;

function checkBreakpoint(breakpoint) {
	let screen = 'medium';
	if (breakpoint === RESOLUTIONS.LOW) {
		screen = 'small';
	} else if (breakpoint === RESOLUTIONS.HIGH) {
		screen = 'large';
	}

	return screen;
}

function onClickEvent(onClick, id, svgId) {
	const element = document.getElementById(id);
	const oldElement = document.querySelector('.active');
	if (oldElement) {
		oldElement.classList.remove('active');
	}
	element.classList.toggle('active');
	if (svgId) {
		document.getElementById(`${svgId}trans1`).beginElement();
	}
	if (onClick) {
		onClick();
	}
}

export const IconButton = ({
	children,
	className,
	id,
	onClick,
	onMouseOver,
	cypressId,
	enabled,
	breakpoint,
	module,
	svgId,
	props,
}) => {
	const enable = enabled ? '' : ' disabled';
	const screen = checkBreakpoint(breakpoint);

	return (
		<Icon
			id={id}
			className={`${className} ${enable} ${screen} ${module}`}
			onClick={enabled ? () => onClickEvent(onClick, id, svgId) : undefined}
			onMouseOver={onMouseOver}
			data-cy={cypressId}
			module={module}
			{...props}
		>
			{children}
			{!enabled && <CircleSlash module={module} className={screen} />}
		</Icon>
	);
};

IconButton.propTypes = {
	children: any,
	className: string,
	id: string,
	onClick: func,
	onMouseOver: func,
	module: any,
	cypressId: string,
	enabled: bool,
	breakpoint: number.isRequired,
	svgId: string,
};

IconButton.defaultProps = {
	children: '',
	className: 'action-button',
	id: 'action-button',
	onClick: () => {},
	onMouseOver: () => {},
	module: 'support',
	cypressId: 'icon-button',
	enabled: true,
	svgId: null,
};
